import { render, staticRenderFns } from "./BaseCopyrights.vue?vue&type=template&id=66572742&"
import script from "./BaseCopyrights.vue?vue&type=script&lang=js&"
export * from "./BaseCopyrights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports